// Module
var code = "<div class=\"side-menu-buttons-content\"> </div> <div class=\"side-menu-page-content\"> </div>";
// Exports
export default code;